// @flow
import React, { Component } from "react";

import LazyLoad from "react-lazyload";
import s from "./MoviesSection.scss";

export default class MoviesSection extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showMovie: false,
      movie: false
    };
  }

  openMovie = movie => {
    this.setState({ showMovie: true });
    this.setState({ movie: movie });
  };

  closeMovie = () => {
    this.setState({ showMovie: false });
  };

  render() {
    return (
      <section className="lp-movies">
        <div className="movies__container container row">
          <div className="movies__main col-12">
            <ul className="movies row">
              <li className="movie col-6 col-s-12">
                <img src={this.props.image01} alt="" />
                <span
                  onClick={() => this.openMovie(this.props.movie1)}
                  className="af-icon-play-button"
                />
           {/*      <div className="item-title">Przygotuj powierzchnię</div> */}
              </li>
              <li className="movie col-6 col-s-12">
                <img src={this.props.image02} alt="" />
                <span
                  onClick={() => this.openMovie(this.props.movie2)}
                  className="af-icon-play-button"
                />
           {/*      <div className="item-title">Przygotuj powierzchnię</div> */}
              </li>
            </ul>

            {this.state.showMovie ? (
              <div className="video__container">
                <span onClick={() => this.closeMovie()} className="af-icon-x" />

                <iframe
                  className="video"
                  width="560"
                  height="315"
                  src={this.state.movie}
                  frameborder="0"
                  allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                  allowfullscreen
                ></iframe>
              </div>
            ) : null}
          </div>
        </div>
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/MovieSection/MovieSection.js